import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import "./consentBottomSheet.css";

const ConsentBottomSheet = ({ show, onAgree, onRemind, isLoading }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [showAnimation, setShowAnimation] = useState(false);

  // Handle animation timing
  useEffect(() => {
    if (show) {
      // Small delay to ensure DOM is ready for the animation
      setTimeout(() => setShowAnimation(true), 50);
    } else {
      setShowAnimation(false);
    }
  }, [show]);

  // Reset checkbox when the sheet closes and reopens
  useEffect(() => {
    if (!show) {
      setIsChecked(false);
    }
  }, [show]);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  return (
    <div className={`bottom-sheet-container ${show ? "show" : ""}`}>
      <Modal
        show={show}
        backdrop="static"
        keyboard={false}
        dialogClassName="consent-bottom-sheet"
        contentClassName="consent-bottom-content"
        className={`consent-bottom-sheet ${showAnimation ? "show" : ""}`}
      >
        <Modal.Body>
          <div className="permission-consent">
            <h4>Permission & Consent</h4>
            <p>
              This inspection report may be used to improve our AI systems and
              for other related business purposes, which may include sharing
              report contents with trusted third parties.
            </p>
            <p>
              By checking the box below, you confirm that you are the homeowner
              and consent to the use and sharing of this report as outlined in
              our:
            </p>
            <div className="links">
              <a
                href="https://www.morph-technologies.com/terms-conditions"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms and Conditions
              </a>
              <a
                href="https://www.morph-technologies.com/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </div>
            <div className="checkbox-container">
              <input
                type="checkbox"
                id="consent-checkbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
              <label htmlFor="consent-checkbox">
                I confirm I'm the homeowner and agree to the use of this report
                in accordance with the Privacy Policy.
              </label>
            </div>
            <div className="button-group">
              <button
                className="agree-btn"
                onClick={() => onAgree(isChecked)}
                disabled={isLoading || !isChecked}
              >
                Agree & Continue
              </button>
              <button
                className="remind-btn"
                onClick={onRemind}
                disabled={isLoading}
              >
                Remind Me Later
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ConsentBottomSheet;
